export default "__VITE_ASSET__6e64e0b2__"